<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="row m-0 p-2 background-primary-blue height-70px shadow z-max align-items-center">
        <div (click)="back()" class="col-2 pt-4 pb-4 btn text-reset d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-chevron-left fa-xl"></i>
        </div>
        <div class="col-8 m-auto d-flex gap-3 justify-content-center align-items-center">
            @if (!loading) {
                <div class="col-auto fs-main text-center color-white">Gateways</div>
            }
            <div class="d-flex gap-2">
                @if (onlineGateways.length > 0) {
                    <div>
                        <app-gateway-svg [backgroundColor]="'#348D1D'"
                                        [height]="'20px'"
                                        [online]="true"
                                        [width]="'20px'"
                                        class="img-fluid img-max m-auto"/>
                        <span class="color-white p-1">{{ onlineGateways.length }}</span>
                    </div>
                }
                @if (unknownGateways.length > 0) {
                    <div>
                        <app-gateway-svg [backgroundColor]="'#dfdfde'"
                                         [height]="'20px'"
                                         [online]="true"
                                         [width]="'20px'"
                                         class="img-fluid img-max m-auto"/>
                        <span class="color-white p-1">{{ unknownGateways.length }}</span>
                    </div>
                }
                @if (offlineGateways.length > 0) {
                    <div>
                        <app-gateway-svg [backgroundColor]="'#FF401F'"
                                         [height]="'20px'"
                                         [online]="false"
                                         [width]="'20px'"
                                         class="img-fluid img-max m-auto"/>
                        <span class="color-white p-1">{{ offlineGateways.length }}</span>
                    </div>
                }
            </div>
        </div>
        <div (click)="close()" class="pointer text-reset col-2 d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-x fa-xl"></i>
        </div>
    </div>
    <div class="d-flex flex-column p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        <div class="mb-3">
            <div class="input-group position-relative">
                <input (input)="filterResults($event.target)"
                       class="form-control m-auto rounded-pill height-50px ps-3 pe-3"
                       placeholder="Search..."
                       style="padding-right: 30px;"
                       type="search">
                <i class="fa-solid fa-magnifying-glass"
                   style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); pointer-events: none;"></i>
            </div>
        </div>
        <div id="gateway-list">
            @for (gateway of filteredGateways(); track gateway.id) {
                <app-gateway-button [id]="gateway.id"
                                    class="mb-2 "/>
            }
        </div>
    </div>
</div>

